<template lang="html">
  <div class="themes">
    <PageHeader>
      <div class="heading">
        <h1>
          Site Theme
        </h1>
      </div>
    </PageHeader>

    <div
      v-for="(theme, index) in themes"
      :key="`theme-${index}`">

      <Theme
        :theme="theme"
        :themeImage="themeImage(theme)"
        :activeTheme="activeTheme"
        @setTheme="setTheme"
        @expanded="handleHeightChange"/>
    </div>
  </div>
</template>

<script>
import Theme from '@/components/Theme'
import PageHeader from '@/components/PageHeader'

export default {
  name: 'Themes',

  props: {
    themes: {
      type: Array,
      required: true
    },

    activeTheme: {
      type: Object
    },

    site: {
      type: Object
    },

    upcomingMode: {
      type: Boolean
    }
  },

  components: {
    Theme,
    PageHeader
  },

  computed: {
    themeImage() {
      return (theme) => {
        if (theme.name.includes('Light')) {
          return 'https://i.postimg.cc/DfX1Twjx/smartmockups-kiemv9eq.jpg'
        } else {
          return 'https://i.postimg.cc/s2h0dc5X/smartmockups-kiemgaf4.jpg'
        }
      }
    }
  },

  methods: {
    setTheme(theme) {
      this.$emit('setTheme', theme)
    },

    handleHeightChange() {
      this.$emit('handleHeightChange')
    }
  }
}
</script>
